
    document.querySelectorAll('[data-hpr]').forEach(function(root){
      if(root.dataset.hprInitialized) return;
      root.dataset.hprInitialized = 'true';
      var SECTION_ID = root.getAttribute('data-hpr');

      (function(){
        var head = root.querySelector('[data-typeheading]');
        if(!head) return;
        var typeEl = head.querySelector('.hpr__type');
        if(!typeEl) return;
        var full = typeEl.getAttribute('data-text') || typeEl.textContent || '';
        var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if(!('IntersectionObserver' in window) || reduce || !full) return;
        typeEl.textContent = '';
        var started = false;
        var hio = new IntersectionObserver(function(entries){
          for(var k=0;k<entries.length;k++){
            if(entries[k].isIntersecting && !started){
              started = true; hio.disconnect();
              head.classList.add('is-typing');
              var i = 0;
              (function step(){
                typeEl.textContent = full.slice(0, i);
                if(i < full.length){ i++; setTimeout(step, 58); }
                else { head.classList.remove('is-typing'); head.classList.add('is-done'); setTimeout(function(){ head.classList.add('caret-fade'); }, 1500); }
              })();
            }
          }
        }, { threshold: 0.35 });
        hio.observe(head);
      })();

      var rail = root.querySelector('[data-rail]');
      if(!rail) return;

      var realCards = [].slice.call(rail.querySelectorAll('.hpr__card:not(.is-clone)'));
      var cloneCount = 0, isProg = false, settleTimer = null, lastW = 0, roTimer = null;

      function allCards(){ return [].slice.call(rail.querySelectorAll('.hpr__card')); }
      function centreOf(card){ return card.offsetLeft - (rail.clientWidth - card.offsetWidth) / 2; }
      function centreX(){ var r = rail.getBoundingClientRect(); return r.left + rail.clientWidth / 2; }
      function nearest(){
        var cards = allCards(), centre = centreX(), best = null;
        for(var i=0;i<cards.length;i++){
          var r = cards[i].getBoundingClientRect();
          var d = Math.abs(r.left + r.width/2 - centre);
          if(!best || d < best.d) best = { card: cards[i], d: d };
        }
        return best ? best.card : null;
      }

      function buildClones(){
        var olds = rail.querySelectorAll('.hpr__card.is-clone');
        for(var o=0;o<olds.length;o++) olds[o].parentNode.removeChild(olds[o]);
        var n = realCards.length;
        if(n < 2){ cloneCount = 0; return; }
        var w = rail.clientWidth || window.innerWidth;
        var cardW = realCards[0].getBoundingClientRect().width || 240;
        var visible = Math.max(2, Math.ceil(w / cardW) + 1);
        cloneCount = Math.min(visible, n);
        function mkClone(srcIdx){
          var el = realCards[srcIdx].cloneNode(true);
          el.classList.add('is-clone'); el.classList.remove('is-active');
          var L = el.querySelectorAll('.hpr__line'); for(var q=0;q<L.length;q++) L[q].classList.remove('is-drawing');
          el.setAttribute('aria-hidden','true'); el.setAttribute('data-ri', String(srcIdx)); el.setAttribute('tabindex','-1');
          return el;
        }
        var bf = document.createDocumentFragment(), af = document.createDocumentFragment();
        for(var c=0;c<cloneCount;c++){
          af.appendChild(mkClone(c % n));
          var bi = (n - 1 - c + n) % n;
          bf.insertBefore(mkClone(bi), bf.firstChild);
        }
        realCards.forEach(function(c,i){ c.setAttribute('data-ri', String(i)); });
        rail.insertBefore(bf, realCards[0]);
        rail.appendChild(af);
      }

      function maybeWrap(){
        var n = realCards.length;
        if(n < 2 || !cloneCount) return;
        var card = nearest();
        if(!card || !card.classList.contains('is-clone')) return;
        var ri = parseInt(card.getAttribute('data-ri'), 10);
        var cards = allCards(), target = null;
        for(var i=0;i<cards.length;i++){
          if(!cards[i].classList.contains('is-clone') && parseInt(cards[i].getAttribute('data-ri'),10) === ri){ target = cards[i]; break; }
        }
        if(!target) return;
        isProg = true;
        rail.classList.add('is-jumping');
        rail.scrollLeft = centreOf(target);
        void rail.offsetWidth;
        rail.classList.remove('is-jumping');
        setTimeout(function(){ isProg = false; }, 30);
      }

      var activeEl = null, activeRi = null, rafScroll = null;

      function applyActive(card, redraw){
        var cards = allCards();
        for(var i=0;i<cards.length;i++){
          if(cards[i] !== card){
            cards[i].classList.remove('is-active');
            var others = cards[i].querySelectorAll('.hpr__line');
            for(var z=0;z<others.length;z++) others[z].classList.remove('is-drawing');
          }
        }
        card.classList.add('is-active');
        if(redraw){
          var lns = card.querySelectorAll('.hpr__line');
          for(var k=0;k<lns.length;k++){ lns[k].classList.remove('is-drawing'); void lns[k].offsetWidth; lns[k].classList.add('is-drawing'); }
        }
        activeEl = card; activeRi = card.getAttribute('data-ri');
      }

      function syncActive(){
        var c = nearest();
        if(!c || c === activeEl) return;
        applyActive(c, c.getAttribute('data-ri') !== activeRi);
      }

      function onSettle(){ maybeWrap(); syncActive(); }

      function onScroll(){
        if(isProg) return;
        if(!rafScroll) rafScroll = requestAnimationFrame(function(){ rafScroll = null; syncActive(); });
        clearTimeout(settleTimer);
        settleTimer = setTimeout(onSettle, 60);
      }

      function initScroll(){
        var cards = allCards(), first = null;
        for(var i=0;i<cards.length;i++){
          if(!cards[i].classList.contains('is-clone') && cards[i].getAttribute('data-ri') === '0'){ first = cards[i]; break; }
        }
        if(!first) first = cards[cloneCount] || cards[0];
        if(!first) return;
        isProg = true;
        rail.classList.add('is-jumping');
        rail.scrollLeft = centreOf(first);
        requestAnimationFrame(function(){
          rail.classList.remove('is-jumping');
          requestAnimationFrame(function(){ isProg = false; });
        });
      }

      rail.addEventListener('keydown', function(ev){
        if(ev.target !== rail || realCards.length < 2) return;
        if(ev.key === 'ArrowLeft' || ev.key === 'ArrowRight'){
          ev.preventDefault();
          var step = realCards[0].getBoundingClientRect().width + 16;
          isProg = true;
          rail.scrollBy({ left: (ev.key === 'ArrowRight' ? 1 : -1) * step, behavior: 'smooth' });
          setTimeout(function(){ isProg = false; onSettle(); }, 460);
        }
      });

      var ro = ('ResizeObserver' in window) ? new ResizeObserver(function(es){
        if(!es || !es[0]) return;
        var w = es[0].contentRect.width;
        if(Math.abs(w - lastW) < 4) return;
        lastW = w;
        clearTimeout(roTimer);
        roTimer = setTimeout(function(){ if(!realCards.length) return; buildClones(); initScroll(); syncActive(); }, 150);
      }) : null;

      function fullInit(){
        if(realCards.length < 2){ return; }
        buildClones();
        initScroll();
        syncActive();
        rail.addEventListener('scroll', onScroll, { passive: true });
        if('onscrollend' in window){ rail.addEventListener('scrollend', onSettle); }
        if(ro){ lastW = rail.clientWidth; ro.observe(rail); }
      }

      document.addEventListener('shopify:section:load', function(e){
        if(!e || !e.detail || String(e.detail.sectionId) !== SECTION_ID) return;
        if(ro){ try{ ro.disconnect(); }catch(err){} }
        rail.removeEventListener('scroll', onScroll);
        realCards = [].slice.call(rail.querySelectorAll('.hpr__card:not(.is-clone)'));
        fullInit();
      });

      fullInit();
    });
